/* eslint-disable flowtype/require-valid-file-annotation, react/jsx-filename-extension */
// This should fix the issue with loading 'page-data' in IE11
// This is a Gatsby code polyfill
import 'core-js/modules/es6.string.ends-with';
import { css, Global } from '@emotion/core';
import ThemeProvider from '@tablekit/theme/ThemeProvider';

export const onRouteUpdate = ({ prevLocation }) => {
  if (prevLocation) {
    window.tsPageInteracted = true;
  }

  if (window.isSatoriLoaded && window.StSegs) {
    window.StSegs.execute();
  }
};

// eslint-disable-next-line react/prop-types, import/prefer-default-export
export const wrapRootElement = ({ element }) => (
  <ThemeProvider>
    <Global
      styles={css`
        body:before {
          content: '';
          position: fixed;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background-color: #000;
          opacity: 0;
          transition: opacity 0.1s ease-in-out;
          pointer-events: none;
          z-index: 99999999999;
        }
      `}
    />
    {element}
  </ThemeProvider>
);
